<template>
	<input
		ref="input" type="text" v-model="formattedValue"
		@click="setCursorPosition($event, true)"
		@focus="setCursorPosition($event, true)"
		@keydown.exact="filterKeys"
		@keydown.left="setCursorPosition"
		@input="onChange">
</template>
<script>
export default {
	data() {
		return {
			rawValue: null,
			formattedNumber: null,
			formattedValue: null,
			formatter: new Intl.NumberFormat("en-UK", {
				style: "currency",
				currency: "GBP",
				useGrouping: "min2",
				maximumFractionDigits: this.fractions ? 2 : 0,
			}),
			timeout: null,
		};
	},

	computed: {
		prefix() {
			if (
				!this.value &&
				!this.displayCurrencyWhenZero
			) {
				return "";
			}
			let parts = this.formatter.formatToParts(this.value);
			let currency = parts.find(part => {
				return part.type === "currency";
			});
			return this.forcePadCurrency ? currency.value + " " : currency.value;
		},
		includeFractions() {
			if (!this.fractions) {
				return false;
			}
			return this.rawValue.includes(".");
		}
	},

	props: {
		value: {},
		fractions: {
			required: false,
			type: Boolean,
			default() {
				return false;
			}
		},
		displayZero: {
			required: false,
			type: Boolean,
			default() {
				return false;
			}
		},
		displayCurrencyWhenZero: {
			required: false,
			type: Boolean,
			default() {
				return true;
			}
		},
		forcePadCurrency: {
			required: false,
			type: Boolean,
			default() {
				return true;
			}
		},
		focusOnMount: {
			required: false,
			type: Boolean,
			default() {
				return false;
			}
		}
	},

	methods: {
		filterKeys(event) {
			let pattern = !this.fractions || this.rawValue.includes(".") ? /[^0-9]/ : /[^0-9\.]/;
			if (
				["ArrowLeft", "ArrowRight", "Tab", "Backspace"].indexOf(event.key) === -1 &&
				pattern.test(event.key)
			) {
				return event.preventDefault();
			}
		},
		setCursorPosition(event, forceToEnd = false) {
			let position = event.target.selectionStart;
			if (position === this.prefix.length) {
				return event.preventDefault();
			}
			if (
				forceToEnd &&
				position < this.prefix.length
			) {
				position = (this.formattedValue || this.prefix).length;
			}
			event.target.selectionStart = position;
			event.target.selectionEnd = position;
		},
		formatNumber(value) {
			let parts = this.formatter.formatToParts(this.rawValue).filter((part) => {
				let filters = this.includeFractions ? ["currency", "literal"] : ["currency", "literal", "decimal", "fraction"];
				return filters.indexOf(part.type) === -1;
			});
			value = parts.map(part => {
				return part.value;
			}).join("");
			if (value === "0" && !this.displayZero) {
				value = "";
			}
			return value;
		},
		formatValue(value) {
			return this.prefix + this.formattedNumber;
		},
		setValues(value) {
			this.rawValue = this.normalizeValue(value);
			clearTimeout(this.timeout);
			this.timeout = null;
			this.timeout = setTimeout(() => {
				this.formattedNumber = this.formatNumber();
				this.formattedValue = this.formatValue();
			}, this.includeFractions ? 750 : 0);
		},
		onChange(event) {
			this.setValues(event.target.value);
		},
		normalizeValue(value) {
			let pattern = this.fractions ? /[^0-9\.]/g : /[^0-9]/g;
			value = (value || "").toString().replace(pattern, "");
			return isNaN(value) ? 0 : value;
		},
	},

	watch: {
		value: {
			immediate: true,
			handler: function (value) {
				this.setValues(value);
			},
		},
		formattedNumber: {
			handler: function (value) {
				let number = this.formattedNumber.replace(/[^0-9\.]/g, "");
				if (parseInt(number) === parseInt(this.value)) {
					return;
				}
				this.$emit("input", number);
			},
		}
	},

	created() {
		if (this.focusOnMount) {
			this.$el.focus();
		}
	}
};
</script>
